import { Navigate } from "react-router";
import { useAppSelector } from "../../stores/hooks";

// Never redirect while the boot refresh is still resolving (ADR-0036) — the
// access token lives in memory, so a fresh tab legitimately looks
// unauthenticated for one round trip. Redirecting there is what sent users to
// /login on every new tab.
export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const restoring = useAppSelector((state) => state.auth.restoring);
  if (restoring) return null;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

export const GuestRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const restoring = useAppSelector((state) => state.auth.restoring);
  // Hold the login page back too, or a restoring session flashes the form
  // before bouncing the user to "/".
  if (restoring) return null;
  return isAuthenticated ? <Navigate to="/" replace /> : <>{children}</>;
};
